import { mapGetters, mapMutations, mapState } from 'vuex';
import ListGroupsObjects from '~/components/ListGroupsObjects';
import TrackedObject from '~/entities/TrackedObject';
import imageGenerator from '~/plugins/handlers/imageGenerator';

export default {
  components: {
    ListGroupsObjects,
  },
  data () {
    return {
      variantList: 'outMonitoring',
      showListObjects: true,
      outMonitoringView: 0,
      rr: true,
      objectToFind: '',
      activeListObjectsSubTab: 0,
      activeSubTab: 0,
      countTabs: 0,
      countSelected: 0,
      modalSelectedObjects: [],
      checkedObjects: [],
      privateGroups: [],
      sharedGroups: [],
      leftIsVisible: true,
      scrollSettings: {
        minScrollbarLength: 60,
      },
    };
  },
  computed: {
    ...mapGetters('listGroupsObjects', ['viewStorage', 'listShowGroupsObjects', 'checkedObjectsOutMonitoring']),
    ...mapGetters('sharedobj', { shared: 'shared' }),
    ...mapGetters('privateobj', { private: 'private' }),
    ...mapGetters('preferences', ['accountingUnitObjects', 'expandSearchObjects']),
    ...mapState('objects', ['selectedObjectsImages']),
    foundObjects () {
      return this.findObjects();
    },
    nonReportingSelectedObjects () {
      return this.getCurrentObjects(Object.values(this.$store.state.objects.items));
    },
    reportingSelectedObjects () {
      return this.activeReport ? this.nonReportingSelectedObjects.filter(item => this.objectsSet.has(item.id)) : [];
    },
    selectedObjects () {
      return this.$route.name === 'reporting' && this.activeReport ? this.reportingSelectedObjects : this.nonReportingSelectedObjects;
    },
    objectsSelectedCount () {
      return this.checkedObjects.length;
    },
    objectsSelectedModalCount () {
      return this.modalSelectedObjects.length;
    },
    isAdmin () {
      return this.$store.state.user.data ? this.$store.state.user.data.isAdmin : false;
    },
  },
  watch: {
    activeListObjectsSubTab (n, o) {
      // console.debug('activeListObjectsTab');
      // console.debug(n);
      if (n === 0) {
        this.outMonitoringView = 0;
      } else if (this.viewStorage === 1 && n === 1) {
        this.outMonitoringView = 1;
      } else if (this.viewStorage === 2 && n === 1) {
        this.outMonitoringView = 2;
      }
      if (this.viewStorage === 0 && n === 1) {
        this.showListObjects = false;
      } else if (this.viewStorage !== 0 && n === 2) {
        this.showListObjects = false;
      } else {
        this.showListObjects = true;
      }
    },
  },
  methods: {
    ...mapMutations('listGroupsObjects', ['setCheckedObjectsOutMonitoring']),
    ...mapMutations('objects', ['mergeSelectedObjectsImages']),
    onCheckedObject (checked) {
      const select = !checked.selected;
      this.sharedGroups.forEach(group => updateSelected(group, select));
      this.privateGroups.forEach(group => updateSelected(group, select));

      function updateSelected (_group, next) {
        const obj = _group.Objects.find(x => x.id === checked.id);
        if (!obj) {
          return;
        }
        const selectedObj = _group.Objects.find(x => x.selected && x.id !== checked.id);
        const group = _group;
        group.Selected = selectedObj ? true : next;
      }
    },
    getCurrentObjects (objects) {
      const triggersMap = {};
      this.triggers?.forEach((trigger) => {
        trigger.Objects.forEach((obj) => {
          if (!triggersMap[obj.Id]) {
            triggersMap[obj.Id] = [];
          }
          triggersMap[obj.Id].push(trigger);
        });
      });
      return objects.map((_item) => {
        // TODO-ref: уххх, давно я не видел таких сайд-эффектов
        // const item = _item;
        // item.selected = false;
        // item.data.image = null;
        const item = _item;
        if (_item.data) {
          item.name = _item.data.Name;
        }
        item.selected = false; // здесь можно добавить проверку наличия id этого объекта в this.checkedObjects
        // item.data.image = null;
        if (this.triggers) {
          item.data.triggers = triggersMap[item.id];
        }
        return item;
      });
    },
    getActiveAccountingUnit (accountingUnit) { // todo спросить
      this.$store.dispatch('sharedobj/getSharedObjects', accountingUnit);
    },
    getGroupsObjects (objects, rawGroups) {
      const TEMPLATE_GROUP = {
        Show: true,
        Visible: false,
        Selected: false,
        Open: true,
      };

      const groupping = rawGroups.map(item => ({
        ...TEMPLATE_GROUP,
        Id: item.Id,
        Name: item.Name,
        Edit: true,
        Objects: [],
      }));
      const groupForOutside = {
        ...TEMPLATE_GROUP,
        Id: 0,
        Name: this.$t('monitoring.nogrouping'),
        Edit: false,
        Objects: [],
      };
      groupping.push(groupForOutside);

      const amountGroups = rawGroups.length;

      // eslint-disable-next-line no-plusplus
      for (let i = objects.length - 1; i > -1; --i) {
        const obj = objects[i];
        let isOutside = true;

        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < amountGroups; ++j) {
          const group = rawGroups[j];
          const objInGroup = group.Objects.find(x => x.Id === (obj.data?.Id ?? obj.Id));
          if (objInGroup) {
            isOutside = false;

            const clearGroup = groupping[j];
            clearGroup.Objects.push(obj);
          }
        }

        isOutside && groupForOutside.Objects.push(obj);
      }

      return groupping;
    },
    changedTabs (currentTabs, previousTabs) {
      // console.debug('changedTabs');
      this.countTabs = currentTabs.length;
    },
    getInfoAboutAllGroups () {
      // this.view = localStorage.view ? JSON.parse(localStorage.view) : 0;
      // await this.getActiveAccountingUnit(this.currentAccountingUnit);
      this.sharedGroups = this.getGroupsObjects(this.selectedObjects, this.shared);
      if (this.listShowGroupsObjects.length !== 0) {
        this.sharedGroups.forEach((item) => {
          const currentItem = this.listShowGroupsObjects.find(child => child.Id === item.Id);
          // console.debug(currentItem);
          if (item.Id === currentItem.Id) {
            // eslint-disable-next-line
            item.Show = currentItem.Show;
          }
        });
      }
      this.privateGroups = this.getGroupsObjects(this.selectedObjects, this.private);
    },
    resolveResetCheckedObjects (listObjects, arr = []) {
      if (this.$refs[listObjects]) {
        this.$refs[listObjects].setCheckedObjects(arr);
      }
    },
    async generateObjectImages (objects) {
      const result = [];
      const imagePromises = [];
      // eslint-disable-next-line no-restricted-syntax,no-unused-vars,no-plusplus
      for (let i = 0; i < objects.length; i++) {
        const obj = objects[i];
        imagePromises.push(this.imGen(obj.data?.Icon || obj.Icon).then((image) => {
          result.push({ [obj.id]: image });
          if (obj.data) {
            obj.data.image = image;
          } else {
            obj.image = image;
          }
        }));
      }
      await Promise.all(imagePromises);
      this.mergeSelectedObjectsImages(Object.assign({}, ...result));
    },
    findObjects () {
      const prepared = this.objectToFind.toLowerCase();
      const command = TrackedObject.takeCommand(prepared);
      const property = TrackedObject.takeProperty(prepared, command);
      // console.debug('findObjects - property', { expandSearchObjects: this.expandSearchObjects, command, property, prepared, selectedObj: this.selectedObjects });

      if (property.isValid) {
        return TrackedObject.filterObjectsByProperty(property, this.selectedObjects);
      }
      if (!command) {
        return TrackedObject.filterObjectsByName(this.expandSearchObjects, prepared, this.selectedObjects);
      }
      return this.selectedObjects;
    },
    async imGen (icon) {
      const file = `${process.env.API_ADDRESS}/v1/GetIconImage(Id='${icon.IconFile}')`;
      const image = await imageGenerator({
        file,
        size: icon.Size,
        offset: [icon.X, icon.Y],
      });
      return image;
    },
    clearSelectedAndCheckedObjects (listObjects) {
      this.modalSelectedObjects = [];
      this.checkedObjects = [];
      this.resolveResetCheckedObjects(listObjects);
    },
    closeLeft (ev) {
      if (this.variantList === 'monitoring') {
        this.objectToFind = '';
        this.checkedObjects = [];
      }
      ev.preventDefault();
      this.leftIsVisible = false;
    },
    showLeft (ev) {
      ev.preventDefault();
      this.leftIsVisible = true;
    },
  },
};
